module.exports = __webpack_public_path__ + "static/media/Client.0566df08.svg";